<template>
  <section>
    <h1
      class="primary--text headline pt-8"
    >
      {{ titulo }}
    </h1>

    <v-img
      :alt="imgAlt"
      :src="require(`@/assets/img/${imgSrc}`)"
      :height="imgHeight"
      :width="imgWidth"
      class="mt-0"
    />
  </section>
</template>

<script>
export default {
  name: 'NenhumaCompra',

  props: {
    titulo: {
      type: String,
      requeride: true,
      default: '',
    },
  },

  data() {
    return {
      imgAlt: 'Imagem ilustrativa para nenhuma compra realizada nesta seção.',
      imgSrc: 'nenhuma-compra.svg',
      imgHeight: '183',
      imgWidth: '280',
    };
  },
};
</script>
